import { CircleDollarSignIcon } from 'lucide-react';
import { Fragment } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import styles from '../DetailsSection.module.scss';

type ContextChangesProps = { context_changes: Record<string, number>; isSubsteps?: boolean };

export const ContextChanges = ({ context_changes, isSubsteps = false }: ContextChangesProps) => {
  const { t } = useTranslation();

  if (!context_changes) {
    return null;
  }

  const contextChange = {
    '0': t('activityLogs.updated'),
    '1': t('try_it.details.added'),
    '-1': t('activityLogs.removed'),
  };

  return (
    <span
      className={cn(styles.contextChanges, { [styles['contextChanges--substeps']]: isSubsteps })}
    >
      {isSubsteps && (
        <>
          <CircleDollarSignIcon size={14} className="text-foreground-muted" />
          <span className="text-sm leading-5 font-normal text-foreground-muted">
            {t('common.context')}
          </span>
        </>
      )}

      {Object.keys(context_changes).map((key, index) => {
        return (
          <Fragment key={key}>
            <span className="text-sm leading-5 font-normal text-foreground-muted">
              <span
                className={cn(
                  'text-sm leading-5 font-normal text-foreground-muted',
                  styles.contextVariable
                )}
              >
                ${key}
              </span>{' '}
              {contextChange[context_changes[key].toString()]}
            </span>

            {index < Object.keys(context_changes).length - 1 && ', '}
          </Fragment>
        );
      })}
    </span>
  );
};
